<template>
    <dv-border-box-12>
        <div id="alalysis-container2" class="box1"></div>
    </dv-border-box-12>
</template>

<script>
/* eslint-disable */

import * as echarts from "echarts";
import EventBus from "../js/event-bus.js";
export default {
    name: "AnalysisChart2",
    data() {
        return {
            chartData: null,
        };
    },
    mounted() {
        this.getData();
        EventBus.$on("inventoryChangedEvent", (row) => {
            this.getData();
        });
    },
    methods: {
        getData() {
            this.$api
                .getManufactureMonthlyGrowth()
                .then((result) => {
                    if (result.ok === true && result.data) {
                        this.chartData = result.data;
                        this.drawLine();
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        drawLine() {
            // 基于准备好的dom，初始化echarts实例
            let myChart = echarts.init(
                document.getElementById("alalysis-container2")
            );
            // 绘制图表
            myChart.setOption({
                backgroundColor: "transparent",
                tooltip: {
                    trigger: "axis", //触发类型；轴触发，axis则鼠标hover到一条柱状图显示全部数据，item则鼠标hover到折线点显示相应数据，
                    axisPointer: {
                        // 坐标轴指示器，坐标轴触发有效
                        type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
                    },
                },
                legend: {
                    top: 10,
                    textStyle: {
                        fontSize: 10,
                        color: "rgba(255,255,255,.7)",
                    },
                    data: [this.chartData.year.toString(), "环比增速"],
                },
                grid: {
                    left: 80,
                    right: 60,
                    top: 50,
                    bottom: 40,
                },
                xAxis: [
                    {
                        type: "category",
                        axisLine: {
                            lineStyle: {
                                color: "rgba(255,255,255,.2)",
                            },
                        },
                        splitLine: {
                            lineStyle: {
                                color: "rgba(255,255,255,.1)",
                            },
                        },
                        axisLabel: {
                            color: "rgba(255,255,255,.7)",
                        },
                        data: [
                            "1月",
                            "2月",
                            "3月",
                            "4月",
                            "5月",
                            "6月",
                            "7月",
                            "8月",
                            "9月",
                            "10月",
                            "11月",
                            "12月",
                        ],
                        axisPointer: {
                            type: "shadow",
                        },
                    },
                ],
                yAxis: [
                    {
                        type: "value",
                        axisLine: {
                            lineStyle: {
                                color: "rgba(255,255,255,.3)",
                            },
                        },
                        splitLine: {
                            lineStyle: {
                                color: "rgba(255,255,255,.01)",
                            },
                        },
                        axisLabel: {
                            formatter: "{value} kg",
                        },
                    },
                    {
                        type: "value",
                        axisLine: {
                            lineStyle: {
                                color: "rgba(255,255,255,.3)",
                            },
                        },
                        splitLine: {
                            lineStyle: {
                                color: "rgba(255,255,255,.1)",
                            },
                        },
                        axisLabel: {
                            formatter: "{value} %",
                        },
                    },
                ],
                series: [
                    {
                        name: this.chartData.year,
                        type: "bar",
                        itemStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(
                                    0,
                                    0,
                                    0,
                                    1,
                                    [
                                        { offset: 0, color: "#b266ff" },
                                        { offset: 1, color: "#121b87" },
                                    ]
                                ),
                            },
                        },
                        data: this.chartData.amounts,
                    },
                    {
                        name: "环比增速",
                        type: "line",
                        smooth: true,
                        itemStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(
                                    0,
                                    0,
                                    0,
                                    1,
                                    [
                                        { offset: 0, color: "#fffb34" },
                                        { offset: 1, color: "#fffb34" },
                                    ]
                                ),
                            },
                        },
                        yAxisIndex: 1,
                        data: this.chartData.growth,
                    },
                ],
            });
        },
    },
};
</script>
<style lang="less"></style>
